import type { ReactNode } from "react";
import { DictationInput } from "@music-app/ui-components";
import type { DictationGrading } from "@music-app/exercise-generator";
import type { ExerciseRendererProps } from "./types.js";

export function DictationRenderer({
  exercise,
  pendingAnswer,
  gradingResult,
  disabled,
  onAnswerChange,
  onSubmit,
  midiSubscriber,
}: ExerciseRendererProps): ReactNode {
  const sequence = pendingAnswer?.type === "dictation" ? pendingAnswer.sequence : [];
  const graded = gradingResult !== null;
  const dictationGrading = gradingResult?.detail as DictationGrading | null | undefined;

  return (
    <div>
      <DictationInput
        tonalityMode={exercise.meta.tonalityMode ?? "major"}
        tonicMidi={exercise.meta.tonicMidi ?? 60}
        range={exercise.meta.range ?? "narrow"}
        chromaticEnabled={exercise.meta.chromaticEnabled ?? false}
        sequence={sequence}
        onChange={(next) => onAnswerChange({ type: "dictation", sequence: next })}
        perNote={graded ? dictationGrading?.perNote : undefined}
        disabled={disabled}
        expectedLength={exercise.meta.expectedSequence?.length}
        onMidiNoteOn={midiSubscriber}
      />
      {!graded && (
        <div className="mt-4">
          <button
            type="button"
            onClick={() => onSubmit({ type: "dictation", sequence })}
            disabled={disabled || sequence.length === 0}
            className="bg-ink text-paper px-[18px] py-3 font-sans text-sm font-medium hover:bg-accentSoft transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Submit
          </button>
        </div>
      )}
    </div>
  );
}
